export const EMPTY_CATEGORY = {
    id: '',
    slug: '',
    name: ''
};

export const DEFAULT_CATEGORY = '-1';

export const CATEGORIES_IDS = {
    RE_PROPERTIES: ['5158', '5160', '4827', '4833', '5154', '5156'],
    CARS: ['84']
};

export const CATEGORY_ID = {
    MOTORCYCLE: '200',
    USED_CAR: '198',
    HANDPHONE: '208'
};
